import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export function useProducts(network?: string) {
  return useQuery({
    queryKey: ['catalog', 'products', network],
    queryFn: () => api.products(network ? { network } : undefined),
  });
}

export function useProduct(slug: string) {
  return useQuery({
    queryKey: ['catalog', 'product', slug],
    queryFn: () => api.product(slug),
    enabled: Boolean(slug),
  });
}
